import { AxiosMessages } from "./_axiosErrorTypes";

export const axiosMessages: AxiosMessages = {
    en: {
        AXIOS_ERROR_401: 'Unauthorized access',
        AXIOS_ERROR_403: 'Forbidden - you do not have permission to access this resource.',
        AXIOS_ERROR_404: 'Resource not found.',
        AXIOS_ERROR_OCCURRED: 'An unknown error occurred',
        AXIOS_ERROR_SERVICE_UNAVAILABLE: 'TC.gate is temporarily unavailable while services are being updated. Please try again in a few minutes.',
        AXIOS_ERROR_REQUEST: 'Error setting up the request',
    },
    de: {
        AXIOS_ERROR_401: 'Unbefugter Zugriff',
        AXIOS_ERROR_403: 'Verboten - Sie haben keine Berechtigung, auf diese Ressource zuzugreifen.',
        AXIOS_ERROR_404: 'Ressource nicht gefunden.',
        AXIOS_ERROR_OCCURRED: 'Ein unbekannter Fehler ist aufgetreten',
        AXIOS_ERROR_SERVICE_UNAVAILABLE: 'TC.gate ist während der Aktualisierung der Dienste vorübergehend nicht verfügbar. Bitte versuchen Sie es in einigen Minuten erneut.',
        AXIOS_ERROR_REQUEST: 'Fehler beim Einrichten der Anfrage',
    },
    fr: {
        AXIOS_ERROR_401: "Accès non autorisé",
        AXIOS_ERROR_403: "Interdit - vous n'avez pas la permission d'accéder à cette ressource.",
        AXIOS_ERROR_404: "Ressource non trouvée.",
        AXIOS_ERROR_OCCURRED: "Une erreur inconnue s'est produite",
        AXIOS_ERROR_SERVICE_UNAVAILABLE: "TC.gate est temporairement indisponible pendant la mise à jour des services. Veuillez réessayer dans quelques minutes.",
        AXIOS_ERROR_REQUEST: "Erreur lors de la configuration de la requête",
    },
    it: {
        AXIOS_ERROR_401: "Accesso non autorizzato",
        AXIOS_ERROR_403: "Vietato - non hai il permesso di accedere a questa risorsa.",
        AXIOS_ERROR_404: "Risorsa non trovata.",
        AXIOS_ERROR_OCCURRED: "Si è verificato un errore sconosciuto",
        AXIOS_ERROR_SERVICE_UNAVAILABLE: "TC.gate è temporaneamente non disponibile durante l'aggiornamento dei servizi. Riprova tra qualche minuto.",
        AXIOS_ERROR_REQUEST: "Errore durante la configurazione della richiesta",
    }
};
